module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image9.108ad33e.webp";